module.exports = __webpack_public_path__ + "img/img14.75799789.svg";